import styles from "@/asserts/styles/formSection.module.less";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { purchaseGroupOptions, unitOptions } from "@/constants";
import { Col, DatePicker, Form, Input, InputNumber, Row, Select } from "antd";
import type { RdRawMaterialRequisitionFormValue } from "../../type";
import { CascaderFields } from "../CascaderFields";
import { SearchMaterial } from "./SearchMaterial";
import { useMaterialGroupOptions } from "@/hooks/services/useSelectOptionsQuery";
import { useRdFormEditable } from "./hooks/useRdFormEditable";
import { useTranslation } from "react-i18next";

export const ApplicationInfoFormFields = () => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { t: tCommon } = useTranslation("common");
  const form = Form.useFormInstance<RdRawMaterialRequisitionFormValue>();
  const { setFieldsValue } = form;

  const materialGroupOptions = useMaterialGroupOptions();
  const { isSupplierInfoFormDisabled } = useRdFormEditable();

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("申请信息")} />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <CascaderFields />

          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="isCurrently"
              label={t("是否现有生产物料")}
              rules={[
                {
                  required: true,
                  message: t("请选择是否现有生产物料"),
                },
              ]}
            >
              <Select
                placeholder={t("请选择")}
                options={[
                  { label: tCommon("是"), value: 1 },
                  { label: tCommon("否"), value: 0 },
                ]}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="materialCode"
              label={
                <>
                  {t("物料编号")}
                  <SearchMaterial
                    onSelect={(material) =>
                      setFieldsValue({
                        materialCode: material?.f101 || null,
                        materialNameCn:
                          material?.f102 || material?.f103 || null,
                        productNameCn: material?.f131 || null,
                      })
                    }
                  />
                </>
              }
              rules={[
                {
                  required: true,
                  message: t("请选择物料"),
                },
              ]}
            >
              <Input placeholder={t("请输入")} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="materialNameCn"
              label={t("物料名称")}
              rules={[
                {
                  required: true,
                  message: t("请选择物料"),
                },
              ]}
            >
              <Input placeholder={t("请输入")} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="productNameCn"
              label={t("相关产品名称")}
            >
              <Input placeholder={t("请输入")} />
            </Form.Item>
          </Col>
          {/* 物料组 必填*/}
          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="materialGroup"
              label={t("物料组")}
              rules={[
                {
                  required: true,
                  message: t("请选择物料组"),
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                placeholder={t("请选择")}
                options={materialGroupOptions}
                disabled={isSupplierInfoFormDisabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="applicationQty"
              label={t("申请数量")}
              rules={[
                {
                  required: true,
                  message: t("请输入申请数量"),
                },
              ]}
            >
              <InputNumber
                min={1}
                placeholder={t("请输入")}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="applicationUnit"
              label={t("单位")}
              rules={[
                {
                  required: true,
                  message: t("请选择单位"),
                },
              ]}
            >
              <Select placeholder={t("请选择")} options={unitOptions} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="purchaseGroup"
              label={t("采购组")}
              rules={[
                {
                  required: true,
                  message: t("请选择采购组"),
                },
              ]}
            >
              <Select
                placeholder={t("请选择")}
                options={purchaseGroupOptions}
                disabled={isSupplierInfoFormDisabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="deliveryDate"
              label={t("要求完成日期")}
              rules={[
                {
                  required: true,
                  message: t("请选择要求完成日期"),
                },
              ]}
            >
              <DatePicker placeholder={t("请选择")} style={{ width: "100%" }} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="projectNo"
              label={t("关联项目编号")}
              rules={[
                {
                  required: true,
                  message: t("请输入关联项目编号"),
                },
              ]}
            >
              <Input placeholder={t("请输入")} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="projectName"
              label={t("关联项目名称")}
              rules={[
                {
                  required: true,
                  message: t("请输入关联项目名称"),
                },
              ]}
            >
              <Input placeholder={t("请输入")} />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </div>
  );
};
